import classNames from 'classnames';
import React from 'react';
import { useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { LookupValueDTO } from '../../../common/types/dto/LookupValueDTO';
import DealerDistrictSelect from '../../common/Components/DealerDistrictSelect';
import VehicleSelectV3 from '../../common/Components/VehicleSelectV3';
import PacksInfo from './PacksInfo';

interface VehiclesLayoutState {
    vehcode: number;
    dealerCode: number;
}

const VehiclesLayout: React.FC = () => {
    const initialState: VehiclesLayoutState = {
        vehcode: -1,
        dealerCode: 0,
    };
    const [state, setState]: [VehiclesLayoutState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    const { t } = useTranslation();

    function onVehicleChange(event: any) {
        setState({
            vehcode: event,
        });
    }

    function onDealerChange(selected: LookupValueDTO<number>) {
        if (selected) {
            setState({
                dealerCode: selected.value,
            });
        } else {
            setState({ dealerCode: 0 });
        }
    }

    return (
        <React.Fragment>
            <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                <div className={classNames(['tabs-panel', 'tabs-panel', 'is-active'])} id="panelPacotes">
                    <h3 className={classNames(['padding-top-1', 'padding-bottom-1'])}>
                        {t(`contractsinvoices:repairPacks.header`)}
                    </h3>
                    <div className={classNames(['row', 'medium-unstack', 'dados-pacotes'])}>
                        <VehicleSelectV3 onChange={onVehicleChange} isMini={false} />
                        <div className={classNames(['columns', 'medium-12'])}>
                            <hr />
                        </div>
                        <DealerDistrictSelect
                            validation={true}
                            onChange={onDealerChange}
                            staticDealerCode={0}
                            disbaleSelectorOnSubmit={false}
                            sideBySideSelectorsDisplay={true}
                            divClassName={classNames(['columns', 'medium-6', 'small-12'])}
                        />
                        <PacksInfo vehcode={state.vehcode} dealerCode={state.dealerCode} vin={''} licensePlate={''} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default VehiclesLayout;
